"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUseFilterItems = exports.useFilterItems = exports.makeGroupDef = void 0;
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var react_1 = require("react");
var hooks_1 = require("../hooks");
var makeGroupDef = function (group, getValue, getLabel) {
    var makeOption = function (item) { return ({ value: getValue(item), label: (getLabel !== null && getLabel !== void 0 ? getLabel : getValue)(item), category: group }); };
    return ({
        group: group,
        checkFn: function (item) { return function (f) { return getValue(item) === f.value; }; },
        makeOptions: function (items) { return (0, uniqBy_1.default)(items.map(makeOption), 'value'); },
    });
};
exports.makeGroupDef = makeGroupDef;
var useFilterItems = function (items, fieldsExtractors, groupChecks, extraChecks) { return (0, exports.makeUseFilterItems)(fieldsExtractors, groupChecks, extraChecks)(items); };
exports.useFilterItems = useFilterItems;
var makeUseFilterItems = function (fieldsExtractors, groupChecks, extraChecks) { return function (items) {
    var _a = __read((0, react_1.useState)([]), 2), selectedFilters = _a[0], setSelectedFilters = _a[1];
    var _b = __read((0, hooks_1.useSearch)(), 2), searchText = _b[0], setSearchText = _b[1];
    var filteredItems = (0, react_1.useMemo)(function () {
        var selectedGroups = (0, groupBy_1.default)(selectedFilters, 'category');
        var filteredServices = (0, isEmpty_1.default)(selectedGroups)
            ? items
            : items === null || items === void 0 ? void 0 : items.filter(function (tool) { return groupChecks
                .every(function (_a) {
                var group = _a.group, checkFn = _a.checkFn;
                return !selectedGroups[group] || selectedGroups[group].some(checkFn(tool));
            }); });
        return !searchText
            ? filteredServices
            : filteredServices === null || filteredServices === void 0 ? void 0 : filteredServices.filter(function (item) { return fieldsExtractors
                .some(function (fN) { var _a; return (_a = fN(item)) === null || _a === void 0 ? void 0 : _a.toString().toLocaleLowerCase().includes(searchText.toLocaleLowerCase()); })
                || (extraChecks === null || extraChecks === void 0 ? void 0 : extraChecks.some(function (fN) { return fN(item, searchText); })); });
    }, [searchText, selectedFilters, items]);
    return [
        filteredItems,
        { searchText: searchText, setSearchText: setSearchText },
        { selectedFilters: selectedFilters, setSelectedFilters: setSelectedFilters },
    ];
}; };
exports.makeUseFilterItems = makeUseFilterItems;
